import * as React from 'react';
import { bindActionCreators, ActionCreator } from 'redux';
import { connect } from 'react-redux';
import { startPoller, pollApi, stopPolling, resetPagination, resetNotifications } from 'src/actions/notificationsActions';
import { Icon, Badge } from 'antd';
import NotificationsModal from './NotificationsModal';

const { useEffect, useState } = React;
interface ReduxProps {
  unreadCount: number;
  pollApi: () => ActionCreator<void>;
  startPoller: () => ActionCreator<void>;
  stopPolling: () => ActionCreator<void>;
  resetPagination: () => ActionCreator<void>;
  resetNotifications: () => ActionCreator<void>;
}
interface IProps extends ReduxProps {
  type: string;
  styles: React.CSSProperties;
  currentModule: string;
}
const NotificationButton = (props: IProps) => {
  const { startPoller, unreadCount, type, resetPagination, resetNotifications, stopPolling, pollApi, styles, currentModule } = props;
  const [isNotificationsVisible, setIsNotificationsVisible] = useState(false);
  useEffect(() => {
    pollApi();
  }, [isNotificationsVisible]);
  useEffect(() => {
    return () => {
      stopPolling();
      resetNotifications();
      resetPagination();
    };
  }, []);
  const handleNotificationsClose = () => {
    resetNotifications();
    resetPagination();
    setIsNotificationsVisible(false);
  };
  const renderNotificationsModal = () => {
    return <NotificationsModal
      visible={isNotificationsVisible}
      type={type}
      handleOnCancel={handleNotificationsClose}
      currentModule={currentModule}
    />;
  };
  return <div style={styles}>
    <Badge count={unreadCount}>
      <Icon type="bell"
        theme="filled"
        style={{ fontSize: 24, color: '#333333' }}
        onClick={() => setIsNotificationsVisible(!isNotificationsVisible)}
      />
    </Badge>
    {renderNotificationsModal()}
  </div>;
};
const mapStateToProps = ({ notificationsReducer }, ownProps) => ({
  unreadCount: notificationsReducer.unreadCount?.all,
});
const mapDispatchToProps = dispatch => bindActionCreators({
  startPoller,
  stopPolling,
  resetPagination,
  resetNotifications,
  pollApi,
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(NotificationButton);